import React, { useEffect, useState } from "react";
import { collection, query, orderBy, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import "../../styles/AVS.css";
import { useNavigate } from "react-router-dom";

function AVS() {
  const [vehicleStats, setVehicleStats] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const getVehicleTypeFromSeries = (vehicleNumber) => {
    if (!vehicleNumber) return "Unknown";
    const normalized = vehicleNumber.toUpperCase().replace(/[\s-]/g, "");
    const specificVehicles = {
      "ABJ3284": "Lake Three-wheeler",
      "DAF5019": "Lake Geep",
      "GW3509": "Lake Lorry",
      "RA9999": "Tractor",
    };
    return specificVehicles[normalized] || "Other";
  };

  useEffect(() => {
    fetchVehicleStats();
    // eslint-disable-next-line
  }, []);

  const fetchVehicleStats = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, "vehicleScans"), orderBy("createdAt", "desc"));
      const snapshot = await getDocs(q);

      let rawData = {};

      snapshot.forEach((doc) => {
        const v = doc.data();
        if (!v.vehicleNumber || !v.meter) return;

        // ✅ filter by hotelName "Centauria Lake" (case-insensitive)
        if (!v.hotelName || v.hotelName.toLowerCase() !== "centauria lake".toLowerCase()) {
          return;
        }

        const vehicleNum = v.vehicleNumber.toUpperCase().replace(/[\s-]/g, "");

        // Skip if vehicle type is "Other"
        if (getVehicleTypeFromSeries(vehicleNum) === "Other") return;
        
        const meterReading = parseFloat(v.meter) || 0;
        const createdAt = v.createdAt?.toDate ? v.createdAt.toDate() : null;
        if (!createdAt) return;

        if (!rawData[vehicleNum]) {
          rawData[vehicleNum] = [];
        }

        rawData[vehicleNum].push({
          meter: meterReading,
          date: createdAt,
        });
      });

      let finalData = [];

      Object.entries(rawData).forEach(([vehicleNum, readings]) => {
        readings.sort((a, b) => a.date - b.date);
        const total = readings[readings.length - 1].meter;

        const now = new Date();
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(now.getDate() - 7);
        const oneMonthAgo = new Date();
        oneMonthAgo.setDate(now.getDate() - 30);
        const oneYearAgo = new Date();
        oneYearAgo.setDate(now.getDate() - 365);

        const weekReadings = readings.filter((r) => r.date >= oneWeekAgo);
        const monthReadings = readings.filter((r) => r.date >= oneMonthAgo);
        const yearReadings = readings.filter((r) => r.date >= oneYearAgo);

        const weekly =
          weekReadings.length > 1
            ? weekReadings[weekReadings.length - 1].meter - weekReadings[0].meter
            : 0;

        const monthly =
          monthReadings.length > 1
            ? monthReadings[monthReadings.length - 1].meter - monthReadings[0].meter
            : 0;

        const yearly =
          yearReadings.length > 1
            ? yearReadings[yearReadings.length - 1].meter - yearReadings[0].meter
            : 0;

        finalData.push({
          vehicleType: getVehicleTypeFromSeries(vehicleNum),
          vehicleNumber: vehicleNum,
          total,
          weekly,
          monthly,
          yearly,
          lastUpdated: readings[readings.length - 1].date,
        });
      });

      setVehicleStats(finalData);
    } catch (error) {
      console.error("Error fetching vehicle stats:", error);
    }
    setLoading(false);
  };

  return (
    <div className="avs-container">
      <button className="home-button" onClick={() => navigate("/admin")}>
        Back
      </button>
      <h2>Vehicle Meter Reading Summary</h2>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="avs-table">
          <thead>
            <tr>
              <th>Vehicle</th>
              <th>Plate NO</th>
              <th>Total Meter</th>
              <th>Weekly</th>
              <th>Monthly</th>
              <th>Yearly</th>
              <th>Last Updated</th>
            </tr>
          </thead>
          <tbody>
            {vehicleStats.length > 0 ? (
              vehicleStats.map((v) => (
                <tr key={v.vehicleNumber}>
                  <td>{v.vehicleType}</td>
                  <td>{v.vehicleNumber}</td>
                  <td>{v.total}</td>
                  <td>{v.weekly}</td>
                  <td>{v.monthly}</td>
                  <td>{v.yearly}</td>
                  <td>
                    {v.lastUpdated
                      ? `${v.lastUpdated.toLocaleDateString("en-GB")} ${v.lastUpdated.toLocaleTimeString("en-GB", {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}`
                      : "N/A"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={{ textAlign: "center" }}>
                  No records found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AVS;
